import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    detection: {
        order: ['querystring','cookie','navigator'],
        lookupQuerystring: 'lng',
        lookupCookie: 'i18next',
        caches: ['cookie']
    },
    fallbackLng: "en",

    interpolation: {
      escapeValue: false
    },
    resources: {
      en: {
        translation: {
          devices_label: "Devices",
          add_device_label: "Add Device",
          never_seen_label: "never seen",
          logout_label: "Logout",
          wname_radialgauge: "Radial Gauge",
          wname_lineargauge: "Linear Gauge",
          wname_linechart: "Linechart",
          wname_imageview: "Image View",
          //general widget settings
          general_word: "General",
          borders_label: "Borders",
          hide_widget_label_label: "Hide widget label",
          //special widget settings
          special_word: "Special",
          min_val_label: "Minimum Value",
          max_val_label: "Maximum Value",
          lower_limit_label: "Lower Limit",
          upper_limit_label: "Upper Limit",
          show_tickmarks_label: "Show tick marks",
          widget_configuration_label: "Widget configuration",
          show_axes_label: "Show Axes",
          nb_last_values_label: "Number of historical values",
          image_url_label: "Image URL",
          image_layout_label: "Image Layout",
          interval_label: "Interval",
          last_hour_label: "Last hour",
          last_24h_label: "Last 24 hours",
          last_week_label: "Last week",
          last_month_label: "Last month",
          last_year_label: "Last year",
          //device prop labels
          deviceprop_name_label: "Device name",
          deviceprop_color_label: "Color",
          deviceprop_geo_label: "Geo location",
          //sensor prop labels
          sensorprop_name_label: "Sensor name",
          sensorprop_value_label: "Sensor value",
          sensorprop_unit_label: "Unit",
          sensorprop_time_label: "Timestamp",
          sensorprop_color_label: "Color",
          sensorprop_geo_label: "Geo location",
          sensorprop_value_factor_label: "Factor",
          sensorprop_value_offset_label: "Offset",
          //device + sensor config misc
          manual_word: "Manual",
          delete_device_prompt:
            "Are you sure you wish to delete this device? This will also delete all historical sensor data associated with the sensors, which currently belong to this device.",
          delete_device_label: "Delete device",
          reset_config_prompt:
            "Are you sure you wish to reset this devices configuration? This will clear all configuration information and deletes all attached sensors.",
          reset_config_label: "Reset configuration",
          reset_json_label: "Reset JSON",
          autoconfig_success_label:
            "This device was recognized as an Egnite Querx {{device_qname}} and was configured automatically.",
          autoconfig_prompt:
            "This device was recognized as an Egnite Querx {{json_qname}}. Do you want to configure it automatically?",
          json_noval: "Value not reachable",
          delete_sensor_prompt:
            "Are you sure you wish to delete this sensor? This will also delete all historical sensor data associated with this sensor.",
          delete_sensor_label: "Delete sensor",
          device_config_label: "Device Configuration:",
          device_settings_label: "Device Settings",
          apikey_label: "API key",
          //api key page
          apikey_instr1:
            "This API key has to be set in the device, to associate it with your Palamoa account. There are three alternative ways to achieve this:",
          apikey_instr2:
            "Here, the API key is part of the URL. This is the simplest method.",
          apikey_instr3:
            "Here, the API key will be included in a special HTTP header field. You need access to configure custom HTTP header fields on your device, to use this method.",
          apikey_instr4:
            "Here, the API key will be included in the JSON payload. Therefore, it has to be inserted in the root layer of the sent JSON object under the key 'apikey'. You need access to the JSON structure your device emits, to use this method.",
          header_field_label: "HTTP header field",
          sensor_data_label: "sensorData",
          // QR code popup
          qr_heading: "Use Palamoa on your smartphone!",
          qr_text1:
            "You can use Palamoa from the palm of your hand! If you do not have the Palamoa App installed on your smartphone, you can get it from the App Stores.",
          qr_heading_login: "QR code login",
          qr_text2:
            "To log into the App, besides manually entering your Palamoa credentials, you can tap on 'Scan QR Code' in the App and point your device on the following image:",
          close_word: "Close",
          reload_word: "Reload",
          // Template popup
          "detected_word": "detected",
          "template_prompt":"Should Palamoa configure this device automatically for you?",
          "yes_word": "Yes",
          "no_word": "No",
          "back_label": "Back"
        }
      },
      de: {
        translation: {
          devices_label: "Geräte",
          add_device_label: "Gerät hinzufügen",
          never_seen_label: "nie gemeldet",
          logout_label: "Ausloggen",
          wname_radialgauge: "Zeigerinstrument (radial)",
          wname_lineargauge: "Zeigerinstrument (linear)",
          wname_linechart: "Liniendiagramm",
          wname_imageview: "Bild",
          //general widget settings
          general_word: "Allgemein",
          borders_label: "Rahmen",
          hide_widget_label_label: "Widgetnamen verbergen",
          //special widget settings
          special_word: "Speziell",
          min_val_label: "Minimaler Wert",
          max_val_label: "Maximaler Wert",
          lower_limit_label: "Unterer Grenzwert",
          upper_limit_label: "Oberer Grenzwert",
          show_tickmarks_label: "Teilstriche anzeigen",
          widget_configuration_label: "Widget-Konfiguration",
          show_axes_label: "Achsen anzeigen",
          nb_last_values_label: "Anzahl historischer Werte",
          image_url_label: "Bild-URL",
          image_layout_label: "Bild-Layout",
          interval_label: "Intervall",
          last_hour_label: "Letzte Stunde",
          last_24h_label: "Letzte 24 Stunden",
          last_week_label: "Letzte Woche",
          last_month_label: "Letzter Monat",
          last_year_label: "Letztes Jahr",
          //device prop labels
          deviceprop_name_label: "Gerätename",
          deviceprop_color_label: "Farbe",
          deviceprop_geo_label: "Geo-Koordinaten",
          //sensor prop labels
          sensorprop_name_label: "Sensorname",
          sensorprop_value_label: "Sensorwert",
          sensorprop_unit_label: "Einheit",
          sensorprop_time_label: "Zeitstempel",
          sensorprop_color_label: "Farbe",
          sensorprop_geo_label: "Geo-Koordinaten",
          sensorprop_value_factor_label: "Faktor",
          sensorprop_value_offset_label: "Offset",
          //device + sensor config misc
          manual_word: "Manuell",
          delete_device_prompt:
            "Sind Sie sicher, dass Sie dieses Gerät löschen möchten? Hierdurch werden auch sämtliche Sensordaten, die mit diesem Gerät assoziiert sind gelöscht!",
          delete_device_label: "Gerät löschen",
          reset_config_prompt:
            "Sind Sie sicher, dass Sie die Konfiguration dieses Gerätes löschen möchten? Hierdurch werden ebenfalls alle konfigurierten Sensoren des Gerätes gelöscht.",
          reset_config_label: "Konfiguration zurücksetzen",
          reset_json_label: "JSON zurücksetzen",
          autoconfig_success_label:
            "Dieses Gerät wurde als Egnite Querx {{device_qname}} erkannt und automatisch konfiguriert.",
          autoconfig_prompt:
            "Dieses Gerät wurde als Egnite Querx {{json_qname}} erkannt. Möchten Sie, dass das Gerät automatisch konfiguriert wird?",
          json_noval: "Wert nicht erreichbar",
          delete_sensor_prompt:
            "Sind Sie sicher, dass Sie diesen Sensor löschen möchten? Hierbei werden ebenfalls alle historischen Daten, die mit dem Sensor verknüpft sind gelöscht.",
          delete_sensor_label: "Sensor löschen",
          device_config_label: "Gerätekonfiguration:",
          device_settings_label: "Geräteeinstellungen",
          apikey_label: "API-Key",
          //api key page
          apikey_instr1:
            "Dieser API-KEY muss im Gerät hinterlegt werden, um dieses in Palamoa zuordnen zu können. Dazu gibt es 3 Möglichkeiten:",
          apikey_instr2:
            "Hierbei wird der API-KEY in der URL übergeben. Dies ist die einfachste Möglichkeit.",
          apikey_instr3:
            "Hierbei wird der API-KEY in einem HTTP-Headerfeld namens 'Apikey' übergeben. Hierfür benötigen Sie Zugang zu benutzerdefinierten HTTP-Header-Feldern, die Ihr Gerät mitschickt.",
          apikey_instr4:
            "Hierbei wird der API-KEY in den JSON-Nutzdaten übergeben. Der API-KEY muss dafür in der obersten Ebene des JSON Objektes unter dem JSON-Key 'apikey' hinterlegt werden. Hierfür benötigen Sie die Möglichkeit die JSON-Struktur, die Ihr Gerät absetzt, zu ändern.",
          header_field_label: "HTTP Header-Feld",
          sensor_data_label: "sensorDaten",
          // QR code popup
          qr_heading: "Nutzen Sie Palamoa auf Ihrem Smartphone!",
          qr_text1:
            "Palamoa können Sie auch von unterwegs aus nutzen! Falls Sie die Palamoa App noch nicht haben, können Sie sie aus dem Google PlayStore herunterladen.",
          qr_heading_login: "QR code login",
          qr_text2:
            "Um sich auch der Smartphone-App einzuloggen, können Sie, alternativ zur manuellen Eingabe Ihrer Logindaten, auf 'QR-Code scannen' tappen und das Gerät auf folgendes Bild richten:",
          close_word: "Schließen",
          reload_word: "Neu laden",
          // Template popup
          "detected_word": "erkannt",
          "template_prompt":"Soll Palamoa dieses Gerät automatisch konfigurieren?",
          "yes_word": "Ja",
          "no_word": "Nein",
          "back_label": "Zurück"     
        }
      }
    },

  });

  
export default i18n;
